import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import { useRef, useState } from "react";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { useSearchParams } from "react-router-dom";
import { useGetAdvertDetails } from "../ServerSideStates";
import { setBackEndUlr } from "helpers/SetBackEndUrl";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const LeftImageSlider = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);
  const [searchParams] = useSearchParams();
  const advertId = searchParams.get("id");
  const advertDetails = useGetAdvertDetails(advertId);
  const swiperRef = useRef<any>(null);

  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const goToPrevSlide = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const goToNextSlide = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const handleSlideChange = () => {
    if (swiperRef.current) {
      setIsBeginning(swiperRef.current.swiper.isBeginning);
      setIsEnd(swiperRef.current.swiper.isEnd);
    }
  };
  console.log("buradaaaaa", advertDetails);

  return (
    <div className="">
      <div className="!w-full !h-full !flex gap-2 items-center">
        {!isBeginning && (
          <span
            className="!w-[27px] !h-[23px] !rounded-full !border !border-gray-400 !flex !text-gray-400 items-center justify-center !cursor-pointer hover:text-blue-500 hover:!border-blue-500 absolute left-[25px] z-[3] !text-white !border-white"
            onClick={goToPrevSlide}
          >
            <LeftOutlined className="!text-xs" />
          </span>
        )}

        <Swiper
          loop={false}
          ref={swiperRef}
          spaceBetween={10}
          thumbs={{ swiper: thumbsSwiper }}
          modules={[FreeMode, Navigation, Thumbs]}
          className="mySwiper2 !max-h-[600px] !h-auto !w-full !rounded-lg"
          onSlideChange={handleSlideChange}
          onSwiper={handleSlideChange}
        >
          {advertDetails?.data?.data?.advertMedia.map((item: any, index: number) => (
            <SwiperSlide key={index} className="!h-full !flex !items-center !justify-center">
              
              {item?.media?.contentType.includes("mp4") ? (
                 <video 
                  controls 
                  className="!w-full !h-full !max-h-[600px] !object-contain"
                  style={{ 
                    objectFit: "contain",
                    width: "100%",
                    height: "100%",
                    maxHeight: "600px"
                  }}
                >
                  <source src={setBackEndUlr() + "/" + item?.media?.fullPath} type="video/mp4" />
                </video>
              ) : (
               

                <LazyLoadImage
                  wrapperWidth="100%"
                  wrapperHeight="100%"
                  alt={item?.media?.fullPath}
                  src={setBackEndUlr() + "/" + item?.media?.fullPath}
                  imageClassName="!w-full !h-full !object-contain !max-h-[600px]"
                  style={{ 
                    objectFit: "contain",
                    width: "100%",
                    height: "100%",
                    maxHeight: "600px"
                  }}
                  preview={true}
                />
              )}
            </SwiperSlide>
          ))}
        </Swiper>

        {!isEnd && (
          <span
            className="!w-[27px] !h-[23px] !rounded-full !border !border-gray-400 !text-gray-400 !flex items-center justify-center !cursor-pointer hover:text-blue-500 hover:!border-blue-500 absolute right-[25px] z-[3] !text-white !border-white"
            onClick={goToNextSlide}
          >
            <RightOutlined className="!text-xs" />
          </span>
        )}
      </div>

      <Swiper
        onSwiper={setThumbsSwiper}
        loop={false}
        breakpoints={{
          0: { slidesPerView: 4, spaceBetween: 10 },     
          576: { slidesPerView: 4, spaceBetween: 10 },   
          768: { slidesPerView: 4, spaceBetween: 10 },   
          1024: { slidesPerView: 6, spaceBetween: 10 },  
          1200: { slidesPerView: 6, spaceBetween: 20 },  
          1400: { slidesPerView: 6, spaceBetween: 20 }   
        }}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="!mt-4"
      >
        {advertDetails?.data?.data?.advertMedia.map((item: any, index: number) => (
          <SwiperSlide
            key={index}
            className="!h-[80px] md:!h-[120px] flex items-center justify-center cursor-pointer !border !border-gray-200 !rounded-md !p-2 overflow-hidden"
          >
            {item?.media?.contentType.includes("mp4") ? (
              <video
                controls={false}
                className="!w-full !h-full !object-cover"
                style={{ 
                  objectFit: "cover",
                  width: "100%",
                  height: "100%"
                }}
              >
                <source src={setBackEndUlr() + "/" + item?.media?.fullPath} type="video/mp4" />
              </video>
            ) : (
              <LazyLoadImage
                wrapperWidth="100%"
                classNames="!w-full !h-full"
                wrapperHeight="100%"
                imageClassName="!rounded-sm !object-cover !w-full !h-full"
                alt={item?.media?.fullPath}
                src={setBackEndUlr() + "/" + item?.media?.fullPath}
                style={{ 
                  objectFit: "cover",
                  width: "100%",
                  height: "100%"
                }}
                preview={true}
              />
            )}



          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default LeftImageSlider;